import { observer } from 'mobx-react-lite';
import styles from './CalendarLeftPane.scss';
import { isBoardViewTypeSelected } from 'owa-calendar-module-store';
import { CalendarPicker, CalendarPickerScenarioId } from 'owa-calendar-picker';
import {
    lazyOpenAddCalendarsPane,
    lazyNavigateToAddCalendarPanel,
    AddCalendarsMenuItemId,
} from 'owa-calendar-addcalendar';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { logUsage } from 'owa-analytics';
import getAnonymousSharingStatus from 'owa-pbp-option-publishing-settings/lib/selectors/getAnonymousSharingStatus';
import * as React from 'react';
import { isMonarchMultipleAccountsEnabled } from 'owa-accounts-store/lib/utils/flights';
import { lazyLaunchAccountConfigDialog } from 'owa-account-config';

export default observer(function CalendarPickerLeftNav() {
    const isSurfaceViewType = !isBoardViewTypeSelected();

    return (
        <CalendarPicker
            scenarioId={CalendarPickerScenarioId.SurfaceLeftPane}
            className={styles.calendarPicker}
            showCalendarPicker={isSurfaceViewType}
            onClickAddCalendar={openAddCalendarsClicked}
            onClickAddAccount={openAccountConfigDialog}
            onClickAccountSettings={accountSettingsOnClick}
            onClickAddTeamsCalendar={openAddTeamsCalendarsClicked}
            onClickSetupBooking={openBookingPage}
        />
    );
});

/**
 * Called when 'Add calendars' gets clicked
 */
function openAddCalendarsClicked() {
    lazyOpenAddCalendarsPane.importAndExecute('CalendarSurfaceLeftNav');
}

/**
 * Called when 'Add accounts' gets clicked
 */
function openAccountConfigDialog() {
    lazyLaunchAccountConfigDialog.importAndExecute();
}

/**
 * Called when 'Add Teams calendars' gets clicked
 */
async function openAddTeamsCalendarsClicked() {
    await lazyOpenAddCalendarsPane.importAndExecute('TeamsCalendarGroupHeader');
    lazyNavigateToAddCalendarPanel.importAndExecute(AddCalendarsMenuItemId.TeamsCalendars);
}

/**
 * Called when 'Account settings' is clicked from the account header context menu
 */
function accountSettingsOnClick() {
    logUsage('accountSettingsClicked', { source_1: 'accountContextMenu' });
    if (isMonarchMultipleAccountsEnabled()) {
        lazyMountAndShowFullOptions.importAndExecute('accounts-category', 'accounts-subcategory');
    } else {
        lazyMountAndShowFullOptions.importAndExecute('calendar', 'calAccounts');
    }
}

/**
 * Called when 'Setup/Manage Personal Bookings' is clicked, directing the user to thier personal bookings page
 */
function openBookingPage() {
    window.open('/findtime/booking?ep=calendar', '_blank');
    logUsage('onClickPersonalBookingButtonOWACalendar', {
        entryPoint: 'booking',
        bookingsAlreadySetup: getAnonymousSharingStatus(),
    });
}
